<template>
  <VisaForm country="sri_lanka" :products>
    <template #visa_select="{ form }">
      <BasketFields :form :products />
      <EntryFields v-model="form.entry" has-port />
      <TermsCheckbox v-model="form.termsAgreed" />
    </template>

    <template #details="{ form }">
      <ClientFields v-model="form.client" />
      <AddressFields v-model="form.address" />
      <StayAddress v-model="form.stayAddress" />
      <PassportDetailsNotes />
      <ApplicantInfo
        v-for="(applicant, i) in form.applicants"
        :applicant="applicant"
        :index="i"
      >
        <template #passport>
          <PassportFields v-model="applicant.passport" has-issue-date />
        </template>
      </ApplicantInfo>
    </template>

    <template #review />
    <template #payment />
  </VisaForm>
</template>

<script setup lang="ts">
import type { Product } from '~/types';

defineProps<{
  products: Product[];
}>();
</script>